import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'


export class TBankerForwarder extends React.Component<Tgcc.BaseProps, any>{    
    componentWillMount(){
        browserHistory.replace(Tgcc.Routes.Tbanker(this.props.location.query.cowaction));
    }
    render(){
        return null;
    }
}
